<template>
  <div
      :class="[b(), className]"
      :style="styleSizeName"
      @dblclick="handleDblClick"
  >
    <ChartNav @multiDrill="multiDrill" :currentDrillRouteIndex="currentDrillRouteIndex" @multiJump="multiJump"
              :multiActionsParam="multiActionsParam" v-model="drillIndex" :prop='prop'
              :option="option"
              :drillClickList="drillClickList"
              :drillDimList="drillDimList"></ChartNav>
    <el-tooltip
        popper-class="textarea-model-tool-item"
        :content="option.tipsContent || textValue"
        :disabled="isShowTool()"
        placement="top"
    >
      <div :style="styleChartName" ref="box" :class="b('box')" @click="handleTextClick">
        <span
            ref="text"
            :style="styleName"
        >
          {{ textValue }}
          <span ref="calcText" class="calcText" style="">{{ textValue }}</span>
        </span>
      </div>
    </el-tooltip>
  </div>
</template>

<script>

export default {
  name: "textAreaModel",
  data() {
    return {
      check: "",
      left: 0,
      textValue: '',
    };
  },
  computed: {
    scroll() {
      return this.validData(this.option.scroll, false);
    },
    linkHref() {
      return this.option.linkHref || "#";
    },
    linkTarget() {
      return this.option.linkTarget || "_self";
    },
    step() {
      return this.option.step || 5;
    },
    speed() {
      return this.option.speed || 100;
    },
    lineHeight() {
      return this.option.lineHeight || 40;
    },
    fontSize() {
      return this.option.fontSize || 30;
    },
    split() {
      return this.option.split;
    },
    textWidth() {
      const textLen = (this.textValue || "").length;
      return textLen * this.fontSize;
    },
    styleName() {
      const {
        fontFamily = ''
      } = this.themeCfg
      let obj = Object.assign(
          {
            width: this.scroll ? this.setPx(this.textWidth) : "100%",
            transform: "translateX(" + this.left + "px)",
            textAlign: this.option.textAlign,
            letterSpacing: this.setPx(this.split),
            textIndent: this.setPx(this.split),
            backgroundColor: this.option.backgroundColor,
            fontWeight: this.option.fontWeight || "normal",
            fontFamily: this.option.fontFamily || fontFamily,
            fontSize: this.fontSize + "px",
            lineHeight: this.lineHeight + "px",
            color: this.option.color || "#333",
            display: 'block',
            wordBreak: 'break-all',
          },
          this.styles
      )
      if (this.option.border) {
        obj['border'] = `${this.option.borderWidth || 1}px solid ${this.option.borderColor || '#ffffff'}`
      }
      if (this.option.textWrap === 'truncate') {
        obj['height'] = this.option.lineMax * (this.lineHeight || 22) + 'px'
        obj['overflow'] = 'hidden'
      } else if (this.option.textWrap === 'wrap' && this.option.lineMax) {
        obj['textOverflow'] = 'ellipsis'
        obj['overflow'] = 'hidden'
        obj['display'] = '-webkit-box'
        obj['-webkit-box-orient'] = 'vertical'
        obj['-webkit-line-clamp'] = this.option.lineMax

      }
      return obj;
    },
  },
  watch: {
    scroll() {
      this.move();
    },
    speed() {
      this.move();
    },
    textValue(val) {
      if (val?.indexOf('&nbsp;') >= 0 || val?.indexOf('<br>') >= 0) {
        this.textValue = val?.replaceAll('&nbsp;', ' ')?.replaceAll('<br>', '')
      }
    }
  },
  created() {
  },
  mounted() {
    this.move();
  },
  methods: {
    handleTextClick(e) {
      this.handleClick({
        event: e
      })
    },
    isShowTool() {
      if (this.option.tipsContent) return false;
      if (this.$refs.box?.clientWidth) {
        const innerWidth = this.$refs.calcText?.offsetWidth
        const outerWidth = this.$refs.box?.clientWidth
        return !(innerWidth > outerWidth && this.option.textWrap === 'wrap')
      }
      return true
    },
    updateChart() {
      if (!this.isDataCenter) {
        this.textValue = this.prop?.textAreaValue
        return;
      }
      let textList = []
      if (this.dataChart?.length) {
        textList = this.dataChart.map(item => {
          return this.generateInnerHtml(item)
        })
      }
      this.textValue = textList.join('')
    },
    generateInnerHtml(data) {
      const dom = document.createElement('div')
      dom.innerHTML = this.prop.textAreaValue
      let text = this.prop.textAreaValue
      let childs = dom.children;
      for (let i = 0; i < childs.length; i++) {
        let child = childs[i];
        for (let j = 0; j < child.children.length; j++) {
          let indi = child.children[j];
          if (indi.className === 'indicator-formula-at-button') {
            let dataSet = JSON.parse(indi.dataset.indicator);
            text = text.replaceAll(`${child.outerHTML}`, data[dataSet.code])
          }
        }
      }
      return text;
    },
    move() {
      clearInterval(this.check);
      if (this.scroll) {
        this.check = setInterval(() => {
          if (this.left < -this.textWidth) {
            this.left = this.width;
          }
          this.left = this.left - this.step;
        }, this.speed);
      } else {
        this.left = 0;
      }
    },
  },
  props: {
    option: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
</script>
<style lang="scss">
.textarea-model-tool-item {
  max-width: 600px;
}

.calcText {
  position: absolute;
  z-index: -10;
  opacity: 0;
  display: block;
  white-space: nowrap;
}
</style>
